import { useState } from "react";
import SectionHead from "./SectionHead";
import { GOD_COMMENTS, GOD_TABS } from "../../../mocks/chigua";

function CommentCard({ item }: { item: (typeof GOD_COMMENTS)[number] }) {
  const [liked, setLiked] = useState(false);
  return (
    <article className="group relative flex flex-col justify-between rounded-lg border border-background-200/80 bg-background-50 p-5 hover:border-primary-200 transition-colors">
      <div>
        <div className="flex items-center justify-between gap-2 mb-3">
          <span className="text-xs text-foreground-500 inline-flex items-center gap-1.5">
            <i className="ri-discuss-line text-primary-600" /> 出自 · {item.topic}
          </span>
          <span className="text-[11px] tracking-wider rounded-sm bg-accent-500 px-1.5 py-0.5 text-foreground-950 whitespace-nowrap">
            {item.tag}
          </span>
        </div>
        <div className="relative">
          <i className="ri-double-quotes-l absolute -left-1 -top-2 text-4xl text-primary-200" />
          <p className="relative pl-4 pt-1 font-heading text-lg md:text-xl leading-relaxed font-semibold text-foreground-950">
            {item.text}
          </p>
        </div>
      </div>
      <div className="mt-5 pt-4 border-t border-dashed border-background-300/70 flex items-center justify-between">
        <span className="inline-flex items-center gap-2 text-sm text-foreground-700">
          <span className="grid h-7 w-7 place-items-center rounded-full bg-primary-100 text-primary-700 text-xs font-bold">
            {item.author.slice(1, 2)}
          </span>
          {item.author}
        </span>
        <div className="flex items-center gap-2">
          <button
            onClick={() => setLiked((v) => !v)}
            className={
              "inline-flex items-center gap-1.5 rounded-full px-3 py-1.5 text-xs transition-colors whitespace-nowrap " +
              (liked
                ? "bg-primary-600 text-background-50"
                : "bg-background-100 text-foreground-700 hover:bg-primary-100 hover:text-primary-700")
            }
          >
            <i className={liked ? "ri-thumb-up-fill" : "ri-thumb-up-line"} />
            {liked ? "已围观" : item.likes}
          </button>
          <span className="inline-flex items-center gap-1 text-xs text-foreground-500">
            <i className="ri-reply-line" /> {item.replies}
          </span>
        </div>
      </div>
    </article>
  );
}

export default function GodComments() {
  const [tab, setTab] = useState(0);
  return (
    <section id="god" className="scroll-mt-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-10 md:py-16">
        <SectionHead
          no="03"
          kicker="Comments · 神评论"
          title="抓奸实录神评论 · 高能墙"
          sub="每一条都是评论区里点赞最先冲破五位数的嘴替金句。话题即来源、评论即主角，扫一遍就懂什么叫一句话顶一万句。"
          right="捞更多神评论"
        />

        <div className="inline-flex items-center rounded-full border border-background-300/80 bg-background-100 p-1 mb-6">
          {GOD_TABS.map((t, i) => (
            <button
              key={t}
              onClick={() => setTab(i)}
              className={
                "px-4 py-1.5 rounded-full text-sm transition-colors whitespace-nowrap " +
                (tab === i ? "bg-primary-600 text-background-50 font-medium" : "text-foreground-600 hover:text-primary-700")
              }
            >
              {t}
            </button>
          ))}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {GOD_COMMENTS.map((c, i) => (
            <CommentCard key={c.id} item={c} />
          ))}
        </div>
      </div>
    </section>
  );
}